(function () {

  function initProductGallery(gallery) {
    if (!gallery) return;
    if (gallery.dataset.hfGalleryInitialized === 'true') return;
    gallery.dataset.hfGalleryInitialized = 'true';

    var thumbsContainer = gallery.querySelector('[data-hf-gallery-thumbs]');
    var slides          = Array.from(gallery.querySelectorAll('[data-hf-slide]'));
    var thumbs          = Array.from(gallery.querySelectorAll('[data-hf-thumb]'));

    if (!slides.length || !thumbs.length) return;

    // ── Variant image map ────────────────────────────────────────────────
    // Built by the liquid from variant.metafields.custom.variant_images
    // Format: { "variantId": ["v-ID-0", "v-ID-1", ...], ... }
    var mapScript       = gallery.querySelector('[data-variant-image-map]');
    var variantImageMap = mapScript ? JSON.parse(mapScript.textContent || '{}') : {};

    // ── Deactivate all slides and thumbs ─────────────────────────────────
    function deactivateAll() {
      slides.forEach(function (slide) {
        slide.hidden = true;
        slide.classList.remove('is-active');
        slide.setAttribute('aria-hidden', 'true');

        // Pause any playing video by blanking the iframe src
        var iframe = slide.querySelector('iframe[data-src]');
        if (iframe) iframe.src = 'about:blank';
      });
      thumbs.forEach(function (thumb) {
        thumb.classList.remove('is-active', 'hf-thumb--active');
        thumb.setAttribute('aria-pressed', 'false');
      });
    }

    // ── Activate a slide + its thumb by slide key ─────────────────────────
    function activateMedia(key, scrollThumb) {
      if (scrollThumb === undefined) scrollThumb = true;
      if (!key) return false;

      var slide = gallery.querySelector('[data-hf-slide][data-media-id="' + key + '"]');
      var thumb = gallery.querySelector('[data-hf-thumb][data-media-id="' + key + '"]');

      if (!slide && !thumb) return false;

      deactivateAll();

      if (slide) {
        slide.hidden = false;
        slide.classList.add('is-active');
        slide.setAttribute('aria-hidden', 'false');

        // Lazy-load the iframe — swap data-src → src on first activation
        var iframe = slide.querySelector('iframe[data-src]');
        if (iframe && iframe.src === 'about:blank') {
          iframe.src = iframe.getAttribute('data-src');
        }
      }

      if (thumb) {
        thumb.classList.add('is-active', 'hf-thumb--active');
        thumb.setAttribute('aria-pressed', 'true');
        if (scrollThumb) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }

      return true;
    }

    // ── Reorder the thumb scroller ───────────────────────────────────────
    // Current variant's thumbs → static thumbs.
    // Other variants' thumbs are hidden.
    // Uses data-variant-id and data-media-static attributes set by liquid.
    function reorderThumbs(variantId) {
      if (!thumbsContainer) return;

      var variantThumbs = [];
      var staticThumbs  = [];

      thumbs.forEach(function (thumb) {
        var thumbVariantId = thumb.getAttribute('data-variant-id');
        var isStatic       = thumb.hasAttribute('data-media-static');

        if (isStatic) {
          thumb.style.display = '';
          staticThumbs.push(thumb);
        } else if (thumbVariantId === String(variantId)) {
          thumb.style.display = '';
          variantThumbs.push(thumb);
        } else {
          thumb.style.display = 'none';
        }
      });

      // Physically reorder in DOM: variant first, static after
      variantThumbs.concat(staticThumbs).forEach(function (thumb) {
        thumbsContainer.appendChild(thumb);
      });
    }

    // ── Apply a variant: reorder + activate its first image ──────────────
    function applyVariant(variantId, scrollToFirst) {
      if (scrollToFirst === undefined) scrollToFirst = true;

      var keys = variantId && variantImageMap[String(variantId)]
        ? variantImageMap[String(variantId)]
        : [];

      reorderThumbs(variantId);

      if (keys.length > 0) {
        activateMedia(keys[0], scrollToFirst);
        return;
      }

      // Variant has no metafield images — fall back to first static thumb
      var firstStatic = null;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].hasAttribute('data-media-static')) {
          firstStatic = thumbs[i];
          break;
        }
      }
      if (firstStatic) {
        activateMedia(firstStatic.getAttribute('data-media-id'), scrollToFirst);
      }
    }

    // ── Thumb click handler ──────────────────────────────────────────────
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        activateMedia(this.getAttribute('data-media-id'), true);
      });
    });

    // ── Initialise on page load ───────────────────────────────────────────
    var productSection = gallery.closest('#product-detail-section');
    var productForm    = productSection
      ? productSection.querySelector('form[data-product-form]')
      : null;

    var idInput       = productForm ? productForm.querySelector('input[name="id"]')  : null;
    var idSelect      = productForm ? productForm.querySelector('select[name="id"]') : null;
    var initVariantId = (idInput && idInput.value) || (idSelect && idSelect.value) || null;

    // Reorder and activate — no scroll on first load
    applyVariant(initVariantId, false);

    // Honour data-default-media-id if liquid set a specific starting slide
    var defaultKey = gallery.getAttribute('data-default-media-id');
    if (defaultKey) activateMedia(defaultKey, false);

    // ── Listen for variant:change from variant-buttons.js ────────────────
    if (productForm) {
      productForm.addEventListener('variant:change', function (event) {
        var variant   = (event.detail && event.detail.variant) || null;
        var variantId = variant && variant.id ? String(variant.id) : null;
        applyVariant(variantId, true);
      });
    }
  }

  // ── Boot ─────────────────────────────────────────────────────────────────
  function initAll() {
    document.querySelectorAll('[data-hf-gallery]').forEach(initProductGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

})();